import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from 'src/app/models/core/user.model';

@Component({
  selector: 'app-user-avatar',
  templateUrl: 'user-avatar.component.html',
  styleUrls: ['user-avatar.component.scss'],
  standalone: false
})
export class UserAvatarComponent implements OnInit {

  @Input() public user!: User;
  @Output() public goToProfile = new EventEmitter<void>();

  public userInitials: string | undefined;

  constructor() {}

  public ngOnInit() {
    if (!this.user.fullname.includes(' ')) {
      this.userInitials = this.getUserInitials(this.user.fullname, '');
    } else {
      const firstName = this.user.fullname.split(' ')[0];
      const lastName = this.user.fullname.split(' ')[1];

      this.userInitials = this.getUserInitials(firstName, lastName);
    }
  }

  getUserInitials(firstName: string, lastName: string) {
    let firstLetter = 'TQR';
    let secondLetter = '';

    if (firstName.length > 0) {
      firstLetter = firstName[0].toUpperCase();
    }

    if (lastName.length > 0) {
      secondLetter = lastName[0].toUpperCase();
    }

    return `${firstLetter}${secondLetter}`
  }

}
